import { render, staticRenderFns } from "./communityActivity.vue?vue&type=template&id=5503281a&"
import script from "./communityActivity.vue?vue&type=script&lang=js&"
export * from "./communityActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports